import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { UADetect as UADetectClass, uaDetectToken } from 'go-modules/detect/ua-detect.service';
import { ArchiveFilter, ArchiveFilterTranslations } from '@go-modules/enums/archive-filter';
import { SortOrder, SortOrderTranslations } from '@go-modules/enums/sort-order-main';
import { VIEWS } from '@go-modules/enums/views';
import { ArchivedListDataSource } from '@go-modules/services/archive';
import { ViewStateDataSource } from '@go-modules/services/view-state-datasource/view-state.datasource';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'ngx-archive-view',
	templateUrl: './archive-view.component.html',
	styleUrls: ['./archive-view.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [TranslatePipe],
	standalone: false
})
export class NgxArchiveViewComponent implements OnInit, OnDestroy {
	public readonly views = VIEWS;
	public readonly componentDestroyed = new Subject();
	public currentView: string;
	public form: UntypedFormGroup;
	public filterOptions$: Observable<ArchiveFilter[]>;
	public sortByOptions: SortOrder[] = Object.values(SortOrder).filter((option) => option !== SortOrder.DEFAULT);
	public archiveFilterTranslations = ArchiveFilterTranslations;
	public sortOrderTranslations = SortOrderTranslations;
	public currentView$: Observable<VIEWS>;

	constructor (
		public translatePipe: TranslatePipe,
		public archivedListDataSource: ArchivedListDataSource,
		public viewStateDataSource: ViewStateDataSource,
		@Inject(uaDetectToken) public UADetect: UADetectClass
	) {}

	public ngOnInit () {
		this.currentView$ = this.viewStateDataSource.viewState$;
		this.filterOptions$ = this.archivedListDataSource.availableFilterOptions$;

		this.initializeForm();
		this.form.get('sortBy').valueChanges
			.pipe(takeUntil(this.componentDestroyed))
			.subscribe((selected) => this.archivedListDataSource.sortBy(selected));

		this.form.get('filterBy').valueChanges
			.pipe(takeUntil(this.componentDestroyed))
			.subscribe((selected) => this.archivedListDataSource.filterBy(selected));
	}

	public ngOnDestroy (): void {
		this.componentDestroyed.next(true);
		this.componentDestroyed.complete();
	}

	private initializeForm () {
		this.form = new UntypedFormGroup({
			sortBy: new UntypedFormControl(this.archivedListDataSource.currentSort),
			filterBy: new UntypedFormControl(this.archivedListDataSource.currentFilter)
		});
	}
}
